export const TREASURY_WALLET = 'AK7zZjymK7L3qyFbDRCF1JYuHSXf8s5Yi5GimBAUWbmF';
export const PROGRAM_ID_PLACEHOLDER = '8nvtbUfgM4ZfNLpzJ7PcTX6WWbxNHQHCrdja2idre1o2';
export const COMMITMENT = 'confirmed';
export const SERVER_SEED_LABEL = 'server-seed';
export const CLIENT_SEED_MESSAGE = 'Solante client seed commitment';
export const DEFAULT_MATCH_EXPIRY_SECONDS = 900;
export const DEFAULT_RPC_ENDPOINT = 'https://api.devnet.solana.com';
export const DEFAULT_WEBSOCKET_ENDPOINT = 'wss://api.devnet.solana.com';
export const USDC_DECIMALS = 6;
export const SOL_DECIMALS = 9;
export const HOUSE_FEE_BPS = 300; // 3%
export const HOUSE_PAYOUT_BPS = 10000 - HOUSE_FEE_BPS; // Basis points
export const MATCH_SEED_PREFIX = 'match';
export const ESCROW_VAULT_SEED_PREFIX = 'escrow';
export const SERVER_VERSION = '0.1.0';
export const DEFAULT_MAX_JOKER_SLOTS = 5;
//# sourceMappingURL=constants.js.map